import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useEntityGridConfig } from './entity-grid-config.provider';

export const HotFixEntityGridReadRequest = observer(() => {
  const gridConfig = useEntityGridConfig();

  useEffect(() => {
    gridConfig.resource.read();
  }, []);

  return null;
});
